"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionalsModel = void 0;
class ConditionalsModel {
}
exports.ConditionalsModel = ConditionalsModel;
